import {guid} from '../utils/commonUtility';

class TrackAction {
    constructor(type, source= [], target= [], object={}, barLength, splitIndex, isGlobal = false, gridDivision){
        this.id = guid();
        this.created = Date.now();
        this.type = type;
        this.source = source;
        this.target = target;
        // this.targetTime = this.convertBarsToLength(this.target, barLength);
        // this.sourceTime = this.convertBarsToLength(this.source, barLength);
        this.trackId = isGlobal ? 'global' : object.id;
        this.splitIndex = splitIndex;
        this.gridDivision = gridDivision;
        // let split = objec
        // this.split = object.splits.
    }

    // convertBarsToLength = (bars, barLength) => {
    //     let barTime = {start: 0, end: 0};
    //     if (barLength) {
    //         if (bars && bars.length > 0) {
    //             let copyBars = bars.slice();
    //             copyBars.sort((a, b) => a - b);
    //             barTime = {
    //                 start: copyBars[0] * barLength,
    //                 end: (copyBars[copyBars.length - 1] + 1) * barLength
    //             };
    //         }
    //     }
    //     return barTime;
    // };
}


export default TrackAction;
